export default __webpack_public_path__ + "static/media/yellow-select.14016527.png";